import { gql } from '@apollo/client';
import HrsOnBeatFragment from '@/entities/heart-rate/api/fragments/hrsOnBeatFragment';

const UPDATE_HOLTER_HR_DAILY_SUMMARY_MUTATION = gql`
  mutation updateHolterHrDailySummary($input: UpdateHolterHrDailySummaryInput!) {
    updateHolterHrDailySummary(input: $input) {
      mctDailySummaries {
        date
        isEmpty
        minHr {
          value
          time
          hrsOnBeat {
            ...HrsOnBeatFragment
          }
          userUpdated
        }
        maxHr {
          value
          time
          hrsOnBeat {
            ...HrsOnBeatFragment
          }
          userUpdated
        }
        avgHr {
          value
          userUpdated
        }
        suggestHrsOnBeat {
          minHr {
            avgHr
            ...HrsOnBeatFragment
            userUpdated
          }
          maxHr {
            avgHr
            ...HrsOnBeatFragment
            userUpdated
          }
        }
      }
    }
  }

  ${HrsOnBeatFragment}
`;

export default UPDATE_HOLTER_HR_DAILY_SUMMARY_MUTATION;
